import { CalendarMonthOutlined } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { getIsCalendarEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { NavbarItem } from '@collaborate-health/uikit'

const CalendarTab: React.FC = () => {
  const display = useSelector(getIsCalendarEnabled)
  if (!display) {
    return null
  }

  return <NavbarItem name='Calendar' href={Routes.calendarBase} icon={<CalendarMonthOutlined />} />
}

export default CalendarTab

